export const day_period_list = [
    { value: {start:'5', end: '10'}, label: 'Morning - Before 10:00' },
    { value: {start:'10', end: '13'}, label: 'Around Noon - 10:00-13:00' },
    { value: {start:'13', end: '17'}, label: 'Afternoon - 13:00-17:00' },
    { value: {start:'17', end: '22'}, label: 'Evening - After 17:00' },
  ];